import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";

//Controls
import {
    Modal,
    ModalBody,
    ModalFooter,
    Button,
} from "@gpstrackit/react-controls";

//Actions
import {
    getDeviceReadingRequest,
    clearRedux
} from 'Redux/actions'

import { copyToClipboard } from 'Core/data/Helpers';

import { JsonView, allExpanded, darkStyles, defaultStyles } from 'react-json-view-lite';
import 'react-json-view-lite/dist/index.css';

const DeviceReadingInfo = (props) => {
    const { messages } = useIntl();
    const dispatch = useDispatch();

    const [details, setDetails] = useState(null);

    const { openModal, loading, result, filters } = useSelector(state => state.deviceReadingRedux);

    const closeModal = () => {
        dispatch(clearRedux("RAW_DATA_DEVICE_READING_INFO"));
        setDetails(null);
    }

    useEffect(() => {
        if (openModal && filters) {
            dispatch(getDeviceReadingRequest(filters))
        }
    }, [openModal])

    useEffect(() => {
        if (result) {
            let newResult
            let data = {}
            try {
                data = JSON.parse(result)
                data.deviceData = data?.deviceData ? JSON.parse(data?.deviceData) : data?.deviceData

                //newResult = JSON.stringify(data, undefined, 2)
            } catch (error) {
                let data = JSON.parse(result)
                //newResult = JSON.stringify(data, undefined, 2)
            }
            if (data) {
                try {
                    data.rawMessage = data?.rawMessage ? JSON.parse(data?.rawMessage) : data?.rawMessage
                } catch (error) {
                    let data = JSON.parse(result)
                    console.log('Formatting error in ', data?.rawMessage)
                    //newResult = JSON.stringify(data, undefined, 2)
                }
            }

            setDetails(data)
            dispatch(clearRedux("RAW_DATA_DEVICE_READING_INFO", { result: null }));
        }
    }, [result])

    return (
        <Modal
            open={openModal}
            title={messages['raw_data_tab_device_reading_info']}
            handleClose={() => closeModal()}
            position="right"
            size="small"
            loading={loading}
        >
            <ModalBody>
                <div style={{ padding: '0 10px', marginBottom: 30 }}>
                    {/*  <pre>
                        {details || <div style={{ display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'center', marginTop: 10, opacity: 0.5 }}>{messages['common_no_information_to_display']}</div>}
                    </pre> */}
                    {details && <JsonView data={details} shouldExpandNode={allExpanded} style={defaultStyles} /> || <div style={{ display: 'flex', width: '100%', alignItems: 'center', justifyContent: 'center', marginTop: 10, opacity: 0.5 }}>{messages['common_no_information_to_display']}</div>}
                </div>
            </ModalBody>
            <ModalFooter>
            <Button
                className="btn-cancel"
                    onClick={(e) => {
                        copyToClipboard(JSON.stringify(details), messages['common_copied'])
                    }}
                >
                    {messages['show_raw_data_modal_copy']}
                </Button>
                <Button
                    onClick={() => closeModal()}
                    className="btn-dark-blue"
                >
                    {messages['close']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}

export default DeviceReadingInfo;